// extracted by css-extract-rspack-plugin
export default {"loadingCard":"CreditCard__loading-card--EYGS+","pulse":"CreditCard__pulse--Nlb6w"};